<!--根据传入的性别，返回不同的图片-->
<template>
    <span>
        <img v-if="type === 'M'" src="../assets/images/common/M.svg" :width="width">
        <img v-if="type === 'F'" src="../assets/images/common/F.svg" :width="width">
        <img v-if="type === 'CDTS'" src="../assets/images/common/CDTS.svg" :width="width">
    </span>
</template>

<script>
    export default {
        name: "SexIcon",
        props: {
            // 图片宽度
            width: [Number, String],
            // 图片类型: M、F、CDTS
            type: [String],
        },
    }
</script>

<style scoped>

</style>